module.exports = __webpack_public_path__ + "static/media/tibet.23082c02.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/tibet.svg
// module id = 2224
// module chunks = 0